<button
  pButton
  pTooltip="To be used when a CUSTOMER has requested a date change"
  (click)="editTask()"
  label="Edit Task"
  class="{{ buttonClass }}"
></button>

<p-dialog
  header="Edit Task"
  [(visible)]="showEditTaskDialog"
  [responsive]="true"
  [modal]="true"
  [blockScroll]="true"
  [style]="{ width: '500px', height: '850px' }"
  [closeOnEscape]="false"
  [closable]="false"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row" *ngIf="vehicle">
      <div style="padding: 0 0 15px 5px">
        <b>NOTE: To be used when a CUSTOMER has requested a date change.</b>
      </div>
    </div>

    <div class="task-locations-info" *ngIf="selectedTask">
      <div class="route-information">Route Information</div>
      <div class="ui-grid-row">
        <div class="ui-g-6">Pick-up: {{ selectedTask.pickupLocation.postcode | postcode }}</div>
        <div class="ui-g-6">Distance: {{ currentDistanceMiles }} miles</div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-6">Drop-off: {{ selectedTask.dropoffLocation.postcode | postcode }}</div>
        <div class="ui-g-6">Travel Time: {{ getTravelTime() }}</div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-12">
          Scheduled Date: {{ selectedTask.jobScheduledDate | datex : "ddd DD MMM 'YY HH:mm" }}
        </div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="pickupEarliestDateTime">Pick-up Earliest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="pickupEarliestDateTime"
          id="pickupEarliestDateTime"
          name="pickupEarliestDateTime"
          [minutesInterval]="30"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="pickupLatestDateTime">Pick-up Latest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="pickupLatestDateTime"
          id="pickupLatestDateTime"
          name="pickupLatestDateTime"
          [minutesInterval]="30"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>
      </div>
    </div>

    <div class="notes-title">Pick-up Notes:</div>
    <div class="notes-container">
      <div *ngFor="let note of pickupNotes; let i = index; trackBy: trackByIndex">
        <textarea
          pInputTextarea
          [(ngModel)]="pickupNotes[i].description"
          rows="2"
          style="width: 100%; resize: none"
          name="pickupNote_{{ i }}"
          [class.route-value-text]="true"
          id="pickupNote"
          maxlength="250"
        ></textarea>
      </div>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="dropoffEarliestDateTime">Drop-off Earliest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="dropoffEarliestDateTime"
          id="dropoffEarliestDateTime"
          name="dropoffEarliestDateTime"
          [minutesInterval]="30"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="dropoffLatestDateTime">Drop-off Latest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="dropoffLatestDateTime"
          id="dropoffLatestDateTime"
          name="dropoffLatestDateTime"
          [minutesInterval]="30"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>
      </div>
    </div>

    <div class="notes-title">Drop-off Notes:</div>
    <div class="notes-container">
      <div *ngFor="let note of dropoffNotes; let i = index">
        <textarea
          pInputTextarea
          [(ngModel)]="dropoffNotes[i].description"
          rows="2"
          style="width: 100%; resize: none"
          name="dropoffNote_{{ i }}"
          [class.route-value-text]="true"
          id="dropoffNote"
          maxlength="250"
        ></textarea>
      </div>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4" style="padding-top: 20px">
        <label for="registrationNumber">Vehicle Reg Num:</label>
      </div>
      <div class="ui-g-8">
        <input
          type="text"
          name="registrationNumber"
          pInputText
          style="width: 60%"
          [(ngModel)]="regNumber"
          id="registrationNumber"
          maxlength="8"
        />
        <button
          pButton
          (click)="searchVehicle()"
          icon="fa ui-icon-search"
          style="margin-left: 15px; vertical-align: super"
          [disabled]="isSearchVehicle || !regNumber"
        ></button>
        <div
          style="display: inline-block; vertical-align: -8px"
          class="search-spinner"
          *ngIf="isSearchVehicle"
        >
          <img src="assets/images/loader.gif" alt="Loading" width="35" height="35" />
        </div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4" style="padding-top: 20px">
        <label for="kerbWeight">Kerb Weight (kg):</label>
      </div>
      <div class="ui-g-8" *ngIf="vehicle">
        <input
          type="number"
          name="kerbWeight"
          pInputText
          style="width: 60%"
          [(ngModel)]="vehicle.kerbWeight"
          id="kerbWeight"
          min="350"
          max="20000"
        />
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4" style="padding-top: 20px">
        <label for="fuelType">Fuel Type:</label>
      </div>
      <div class="ui-g-8" *ngIf="vehicle">
        <div class="md-inputfield inputfield-border-container" style="margin-right: 40%">
          <p-dropdown
            id="fuelType"
            class="fuel-type-dropdown"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="vehicle.fuelType"
            [options]="fuelTypes"
            required
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"></div>
      <div class="ui-g-8">
        <div *ngIf="vehicle">
          {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.kerbWeight }}kg
          {{ vehicle.fuelType }}
          {{ vehicle.registrationDate | date : 'yyyy' }}
        </div>
      </div>
    </div>
  </div>
  <div class="ui-grid-row">
    <div class="ui-g-12"></div>
  </div>
  <div class="ui-grid-row" style="float: right; padding-bottom: 10px">
    <button
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="showEditTaskDialog = false"
    ></button>
    <button
      type="button"
      class="green-btn"
      pButton
      icon="fa ui-icon-check"
      (click)="dialogSaveTaskClick()"
      label="Save"
    >
      <div *ngIf="savingChecks" class="saving-checks">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
    </button>
  </div>
</p-dialog>

<p-dialog
  header="Edit Task"
  [(visible)]="showConfirmDates"
  [responsive]="true"
  [modal]="true"
  [blockScroll]="true"
  [style]="{ width: '500px' }"
  [closeOnEscape]="false"
  [closable]="false"
>
  <div>
    The dates/times of this Task are outside the valid range. Are you sure you want to make these
    changes ?
  </div>
  <div class="mt-2 mb-2">
    <div style="display: flex; flex-wrap: wrap; align-items: center; justify-content: center">
      <div style="flex-grow: 1; flex-basis: 100px">
        <table class="show-confirm-dates previous-dates">
          <tr>
            <td colspan="2" class="header">Old Details</td>
          </tr>
          <tr>
            <td class="right">Pick-Up Earliest:</td>
            <td class="the-date">{{ previousPickupEarly | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ previousPickupLate | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
          </tr>
          <tr>
            <td class="right">Drop-Off Earliest:</td>
            <td class="the-date">{{ previousDropoffEarly | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ previousDropoffLate | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
        </table>
      </div>
      <div style="width: 50px; font-size: 30px; height: 100%; text-align: center">
        <i class="fa fa-arrow-right"></i>
      </div>
      <div style="flex-grow: 1; flex-basis: 100px">
        <table class="show-confirm-dates new-dates">
          <tr>
            <td colspan="2" class="header">New Details</td>
          </tr>
          <tr>
            <td class="right">Pick-Up Earliest:</td>
            <td class="the-date">{{ pickupEarliestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ pickupLatestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
          </tr>
          <tr>
            <td class="right">Drop-Off Earliest:</td>
            <td class="the-date">{{ dropoffEarliestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ dropoffLatestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div style="text-align: right; padding-top: 20px">
    <button pButton label="Cancel" class="red-btn" (click)="undoChanges()"></button>
    <button pButton label="Continue" class="green-btn" (click)="saveTaskData()"></button>
  </div>
</p-dialog>
